import React from 'react'
import { useProfile } from '@/lib/hooks/useProfile'
import { useRoute } from '@/lib/RouteContext'
import { memberPagePath } from '@/lib/memberPage'
import { UserProfileDialog } from './UserProfileDialog'
import { ProfileContext, useProfileContext } from './profileContext'

/* Re-exported for the callers; the context itself is in `profileContext.ts`. */
export { useProfileContext }

export const ProfileProvider = ({ children }: { children: React.ReactNode }) => {
  const { profileDialogOpen, selectedMemberId, openProfile: openPreview, closeProfile } = useProfile()
  const { navigate } = useRoute()

  const openProfile = React.useCallback((memberId: string, tab?: string) => {
    if (tab) navigate(memberPagePath(memberId, tab))
    else openPreview(memberId)
  }, [navigate, openPreview])

  const value = React.useMemo(() => ({ openProfile }), [openProfile])

  return (
    <ProfileContext.Provider value={value}>
      {children}
      {selectedMemberId && (
        <UserProfileDialog
          open={profileDialogOpen}
          onOpenChange={(next) => { if (!next) closeProfile() }}
          memberId={selectedMemberId}
        />
      )}
    </ProfileContext.Provider>
  )
}
